import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  DialogActions,
  Dialog,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Paper,
  Typography,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  Chip,
  alpha,
  CircularProgress,
  Stack,
  IconButton,
  Popover,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Badge,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import {
  Save as SaveIcon,
  LocalShipping as TruckIcon,
  Business as BusinessIcon,
  Description as DescIcon,
  Payment as PaymentIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  ArrowBack as ArrowBackIcon,
  Refresh as RefreshIcon,
  CheckBoxOutlineBlank as CheckBoxBlankIcon,
  CheckBox as CheckBoxCheckedIcon,
  RemoveCircleOutline as BlankIcon,
} from "@mui/icons-material";
import {
  freightCreate,
  issueListbyVehilce,
  vehicleList,
  generateLRNumber,
  updateFreight,
  partyList,
  markLRAsBlank,
} from "../../../Services/Services";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { indianStates } from "./states";
import { brandColor as brand } from "../../../theme";

const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    "& fieldset": { borderColor: "#e5e7eb" },
    "&:hover fieldset": { borderColor: "#c7d2fe" },
    "&.Mui-focused fieldset": { borderColor: brand, borderWidth: 1.5 },
  },
  "& .MuiInputLabel-root": { fontSize: "0.78rem", color: "#6b7280" },
  "& .MuiInputLabel-root.Mui-focused": { color: brand },
  "& .MuiFormHelperText-root": { fontSize: "0.72rem", marginLeft: "4px" },
};

const tableFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "4px",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#e5e7eb" },
    "&:hover fieldset": { borderColor: "#c7d2fe" },
    "&.Mui-focused fieldset": { borderColor: brand, borderWidth: 1.5 },
  },
};

const SectionTitle = ({ title, icon: Icon, hint }) => (
  <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2, mt: 1 }}>
    <Box sx={{ width: 3, height: 18, bgcolor: brand, borderRadius: "4px" }} />
    <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "0.85rem" }}>
      {title}
    </Typography>
    {hint && (
      <Typography sx={{ fontSize: "0.72rem", color: "#9ca3af" }}>
        {hint}
      </Typography>
    )}
  </Stack>
);

export default function FreightEntryForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [isEditMode, setIsEditMode] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogOpen1, setDialogOpen1] = useState(false);
  const [showAppPaymentFields, setShowAppPaymentFields] = useState(false);
  const [truckNumberInput, setTruckNumberInput] = useState("");
  const [vehicleType, setVehicleType] = useState("hire");
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const [consignorOptions, setConsignorOptions] = useState([]);
  const [consigneeOptions, setConsigneeOptions] = useState([]);
  const [paymentIssue, setPaymentIssue] = useState([]);
  const [freightOptions, setFreightOptions] = useState([]);
  const [lrNumbers, setLrNumbers] = useState([]);
  const [lrNumber, setLrNumber] = useState("");
  const [generatingLR, setGeneratingLR] = useState(false);
  const [lrConflictDialog, setLrConflictDialog] = useState(false);
  const [brokerOptions, setBrokerOptions] = useState([]);
  const [blankSelectedLRs, setBlankSelectedLRs] = useState([]);
  const [blankReason, setBlankReason] = useState("");
  const [blankConfirmOpen, setBlankConfirmOpen] = useState(false);
  const [blankAnchorEl, setBlankAnchorEl] = useState(null);
  const [markingBlank, setMarkingBlank] = useState(false);

  // ── Single Snackbar state (sab ek jagah manage) ──
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // "success" | "error" | "warning"
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const [packageRows, setPackageRows] = useState([
    {
      id: 1,
      packages: "",
      description: "",
      actual_weight: "0",
      charged_weight: "0",
      rate: "0",
      amount: "0",
    },
  ]);

  const [formData, setFormData] = useState({
    demurrage_days: "",
    demurrage_rate: "",
    packages2: "",
    description2: "",
    actual_weight2: "",
    charged_weight2: "",
    rate2: "",
    amount2: "",
    st_charge: "0",
    delivery_address: "",
    state: "",
    tel_no: "",
    is_consignor: false,
    is_consignee: false,
    is_transporter: false,
    party_id: "",
    branch_id: "",
    consignee_party_id: "",
    broker_party_id: "",
    broker_total_amt: "0",
    broker_net_amt: "0",
    broker_commission_amt: "0",
    lr_number: "",
    created_at: new Date().toISOString().split("T")[0],
    from_location: "",
    to_location: "",
    truck_no: "",
    vehicle_id: "",
    loading_date: "",
    unloading_date: "",
    loading_in_date: "",
    loading_out_date: "",
    unloading_in_date: "",
    unloading_out_date: "",
    do_no: "",
    tp_no: "",
    eway_bill_no: "",
    eway_bill_date: "",
    eway_validity_date: "",
    invoice_no: "",
    packages: "",
    description: "",
    actual_weight: "0",
    charged_weight: "0",
    rate: "0",
    amount: "0",
    freight_rate: "0",
    freight_amt: "0",
    mazdoor_charges: "0",
    service_tax: "0",
    surcharge: "0",
    risk_charges: "0",
    total_amount: "0",
    tds_per: "0",
    tds_amt: "0",
    shortage_rate: "0",
    shortage_amt: "0",
    ad_mines_exp: "0",
    ad_diesel_exp: "0",
    ad_cash_exp: "0",
    total_advance: "0",
    commission: "0",
    other_exp: "0",
    net_amount: "0",
    net_payable: "0",
    consignor_name: "",
    consignor_address: "",
    consignee_bank_name: "",
    consignee_bank_address: "",
    consignee_name: "",
    consignee_address: "",
    transporter_name: "",
    truck_owner: "",
    phone_no: "",
    pan_no: "",
    payment_firm: "",
    received_firm: "",
    name_ac_no: "",
    remark: "",
    cheque_upi_no: "",
    pay_mode: "",
    pay_amount: "0",
    payment_to: "",
    description_payment: "",
    is_remember: false,
    classification_of_goods: "",
    method_of_packing: "",
    additional_info: "",
    value: "",
    vehicle_type: "hire",
  });

  // ── Package Calculations ──────────────────────────────────────────
  const calculatePackageTotal = (rows) => {
    const total = rows.reduce(
      (sum, row) => sum + (parseFloat(row.amount) || 0),
      0,
    );
    setFormData((prev) => ({ ...prev, total_amount: total.toFixed(2) }));
  };

  const handleAddPackageRow = () => {
    const newRows = [
      ...packageRows,
      {
        id: packageRows.length + 1,
        packages: "",
        description: "",
        actual_weight: "0",
        charged_weight: "0",
        rate: "0",
        amount: "0",
      },
    ];
    setPackageRows(newRows);
    calculatePackageTotal(newRows);
  };

  const handleRemovePackageRow = (rowId) => {
    if (packageRows.length === 1) {
      // ── Fix: snackbar state use karo, open/message nahi ──
      showSnackbar("At least one row is required", "warning");
      return;
    }
    const newRows = packageRows.filter((row) => row.id !== rowId);
    setPackageRows(newRows);
    calculatePackageTotal(newRows);
  };

  const handlePackageRowChange = (rowId, field, value) => {
    const updatedRows = packageRows.map((row) => {
      if (row.id === rowId) {
        const updatedRow = { ...row, [field]: value };
        if (updatedRow.rate && updatedRow.charged_weight) {
          updatedRow.amount = (
            parseFloat(updatedRow.rate) * parseFloat(updatedRow.charged_weight)
          ).toFixed(2);
        }
        return updatedRow;
      }
      return row;
    });
    setPackageRows(updatedRows);
    calculatePackageTotal(updatedRows);
  };

  // ── Populate Edit Data ────────────────────────────────────────────
   const populateFormWithData = (editData) => {
    setFormData((prev) => ({
      ...prev,
      created_at: editData.created_at ? editData.created_at.split("T")[0] : (editData.date ? editData.date.split("T")[0] : new Date().toISOString().split("T")[0]),

      party_id: editData.party_id ? parseInt(editData.party_id, 10) : "",
      consignee_party_id: editData.consignee_party_id
        ? parseInt(editData.consignee_party_id, 10)
        : "",
      broker_party_id: editData.broker_party_id
        ? parseInt(editData.broker_party_id, 10)
        : "",
      broker_total_amt: editData.broker_total_amt || "0",
      broker_net_amt: editData.broker_net_amt || "0",
      broker_commission_amt: editData.broker_commission_amt || "0",
      party_name: editData.party_name || "",
      truck_no: editData.truck_no || "",
      from_location: editData.from_location || "",
      to_location: editData.to_location || "",
      loading_date: editData.loading_date || "",
      unloading_date: editData.unloading_date || "",
      loading_in_date: editData.loading_in_date || "",
      loading_out_date: editData.loading_out_date || "",
      unloading_in_date: editData.unloading_in_date || "",
      unloading_out_date: editData.unloading_out_date || "",
      do_no: editData.do_no || "",
      tp_no: editData.tp_no || "",
      eway_bill_no: editData.eway_bill_no || "",
      eway_bill_date: editData.eway_bill_date || "",
      eway_validity_date: editData.eway_validity_date || "",
      invoice_no: editData.invoice_no || "",
      freight_rate: editData.freight_rate || "0",
      freight_amt: editData.freight_amt || "0",
      mazdoor_charges: editData.mazdoor_charges || "0",
      service_tax: editData.service_tax || "0",
      surcharge: editData.surcharge || "0",
      risk_charges: editData.risk_charges || "0",
      tds_per: editData.tds_per || "0",
      tds_amt: editData.tds_amt || "0",
      shortage_rate: editData.shortage_rate || "0",
      shortage_amt: editData.shortage_amt || "0",
      ad_mines_exp: editData.ad_mines_exp || "0",
      ad_diesel_exp: editData.ad_diesel_exp || "0",
      ad_cash_exp: editData.ad_cash_exp || "0",
      total_advance: editData.total_advance || "0",
      commission: editData.commission || "0",
      other_exp: editData.other_exp || "0",
      net_amount: editData.net_amount || "0",
      net_payable: editData.net_payable || "0",
      consignor_name: editData.consignor_name || "",
      consignor_address: editData.consignor_address || "",
      consignee_bank_name: editData.consignee_bank_name || "",
      consignee_bank_address: editData.consignee_bank_address || "",
      consignee_name: editData.consignee_name || "",
      consignee_address: editData.consignee_address || "",
      transporter_name: editData.transporter_name || "",
      truck_owner: editData.truck_owner || "",
      phone_no: editData.phone_no || "",
      pan_no: editData.pan_no || "",
      remark: editData.remark || "",
      pay_amount: editData.pay_amount || "0",
      payment_to: editData.payment_to || "",
      pay_mode: editData.pay_mode || "",
      cheque_upi_no: editData.cheque_upi_no || "",
      description_payment: editData.description_payment || "",
      is_remember: editData.is_remember || false,
      classification_of_goods: editData.classification_of_goods || "",
      method_of_packing: editData.method_of_packing || "",
      additional_info: editData.additional_info || "",
      delivery_address: editData.delivery_address || "",
      state: editData.state || "",
      tel_no: editData.tel_no || "",
      is_consignor: editData.is_consignor || false,
      is_consignee: editData.is_consignee || false,
      is_transporter: editData.is_transporter || false,
      st_charge: editData.st_charge || "0",
      demurrage_days: editData.demurrage_days || "",
      demurrage_rate: editData.demurrage_rate || "",
      value: editData.value || "",
      vehicle_type:
        editData.vehicle_type || (editData.vehicle_id ? "self" : "hire"),
    }));

    if (editData.lr_number) setLrNumber(editData.lr_number);
    setVehicleType(
      editData.vehicle_type || (editData.vehicle_id ? "self" : "hire"),
    );
    if (editData.package_items?.length > 0) {
      const rows = editData.package_items.map((item, idx) => ({
        id: idx + 1,
        packages: item.packages || "",
        description: item.description || "",
        actual_weight: item.actual_weight?.toString() || "0",
        charged_weight: item.charged_weight?.toString() || "0",
        rate: item.rate?.toString() || "0",
        amount: item.amount?.toString() || "0",
      }));
      setPackageRows(rows);
      calculatePackageTotal(rows);
    }
  };

  // ── Effects ───────────────────────────────────────────────────────

  // Edit mode
  useEffect(() => {
    if (id) {
      setIsEditMode(true);
      setLoadingData(true);
      if (location.state?.editData) {
        populateFormWithData(location.state.editData);
      }
      setLoadingData(false);
    }
  }, [id, location.state]);

  // LR Number generate (sirf create mode me)
  useEffect(() => {
    if (!id) {
      const fetchLRNumbers = async () => {
        setGeneratingLR(true);
        try {
          const response = await generateLRNumber();
          if (response?.lr_numbers?.length > 0) {
            setLrNumbers(response.lr_numbers);
            setLrNumber("");
            setFormData((prev) => ({
              ...prev,
              lr_number: "",
            }));
          }
        } catch (error) {
          console.error("Failed to fetch LR numbers:", error);
        } finally {
          setGeneratingLR(false);
        }
      };
      fetchLRNumbers();
    }
  }, [id]);

  // Vehicles
  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await vehicleList("", "", 1);
        let vehicles = [];
        if (response?.data) vehicles = response.data.results || [];
        else if (response?.results) vehicles = response.results || [];
        setVehicleOptions(vehicles);
      } catch (error) {
        console.error("Failed to fetch vehicles:", error);
      }
    };
    fetchVehicles();
  }, []);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, vehicle_type: vehicleType }));
  }, [vehicleType]);

  // Consignor + Consignee + Broker - same API, alag params
  useEffect(() => {
    const fetchPartyOptions = async () => {
      try {
        const [consignorRes, consigneeRes, brokerRes] = await Promise.all([
          partyList({ party_type: "consignor" }),
          partyList({ party_type: "consignee" }),
          partyList({ party_type: "broker" }),
        ]);
        setConsignorOptions(Array.isArray(consignorRes) ? consignorRes : []);
        setConsigneeOptions(Array.isArray(consigneeRes) ? consigneeRes : []);
        setBrokerOptions(Array.isArray(brokerRes) ? brokerRes : []);
      } catch (error) {
        console.error("Failed to fetch party options:", error);
        setConsignorOptions([]);
        setConsigneeOptions([]);
        setBrokerOptions([]);
      }
    };
    fetchPartyOptions();
  }, []);

  // ── Handlers ──────────────────────────────────────────────────────
  const handleVehicleTypeChange = (event, newType) => {
    if (newType !== null) {
      setVehicleType(newType);
      setFormData((prev) => ({
        ...prev,
        truck_no: "",
        vehicle_id: "",
        vehicle_type: newType,
      }));
    }
  };

  const handleVehicleSelect = (event, newValue) => {
    if (newValue) {
      const truckNo = newValue.vehicle_number || newValue.vehicleNumber || "";
      setFormData((prev) => ({
        ...prev,
        truck_no: truckNo,
        vehicle_id: newValue.vehicle_id || newValue.id || "",
        truck_owner: newValue.truck_owner || prev.truck_owner,
        phone_no: newValue.phone_no || prev.phone_no,
        pan_no: newValue.pan_no || prev.pan_no,
      }));
      setTruckNumberInput(truckNo);
      checkTrukIssue(truckNo);
    }
  };

  const safeParseFloat = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const calculateFields = (data) => {
    const updated = { ...data };

    const freight = safeParseFloat(updated.freight_amt);
    const mazdoor = safeParseFloat(updated.mazdoor_charges);
    const serviceTax = safeParseFloat(updated.service_tax);
    const surchargeVal = safeParseFloat(updated.surcharge);
    const stCharge = safeParseFloat(updated.st_charge);
    const risk = safeParseFloat(updated.risk_charges);
    updated.total_amount = (
      freight +
      mazdoor +
      serviceTax +
      surchargeVal +
      stCharge +
      risk
    ).toFixed(2);

    const tdsPer = safeParseFloat(updated.tds_per);
    const totalAmt = safeParseFloat(updated.total_amount);
    updated.tds_amt = ((totalAmt * tdsPer) / 100).toFixed(2);

    updated.total_advance = (
      safeParseFloat(updated.ad_mines_exp) +
      safeParseFloat(updated.ad_diesel_exp) +
      safeParseFloat(updated.ad_cash_exp)
    ).toFixed(2);

    updated.shortage_amt = (
      (safeParseFloat(updated.shortage_wt) || 0) *
      safeParseFloat(updated.shortage_rate)
    ).toFixed(2);

    updated.net_amount = (
      totalAmt -
      safeParseFloat(updated.tds_amt) -
      safeParseFloat(updated.total_advance) -
      safeParseFloat(updated.commission) -
      safeParseFloat(updated.other_exp) -
      safeParseFloat(updated.shortage_amt)
    ).toFixed(2);

    updated.net_payable = updated.net_amount;
    return updated;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
      return;
    }

    if (name === "phone_no") {
      const cleaned = value.replace(/\D/g, "");
      if (cleaned.length > 10) return;
      setFormData((prev) => calculateFields({ ...prev, phone_no: cleaned }));
      return;
    }

    setFormData((prev) => calculateFields({ ...prev, [name]: value }));
  };

  const checkTrukIssue = async (paramTruckNo) => {
    let truck =
      typeof paramTruckNo === "string"
        ? paramTruckNo
        : truckNumberInput || formData.truck_no;

    if (typeof truck !== "string") return;
    truck = truck.trim();
    if (!truck) return;

    try {
      const data = await issueListbyVehilce(truck);
      if (data && typeof data === "object") {
        setFormData((prev) => ({
          ...prev,
          truck_owner: data.truck_info?.truck_owner || prev.truck_owner,
          phone_no: data.truck_info?.phone_no || prev.phone_no,
          pan_no: data.truck_info?.pan_no || prev.pan_no,
          payment_to: data.truck_info?.payment_to || prev.payment_to,
        }));

        const hasIssues = Array.isArray(data.issues) && data.issues.length > 0;
        const hasPayments =
          Array.isArray(data.payments) && data.payments.length > 0;

        if (hasIssues) setFreightOptions(data.issues);
        if (hasPayments) setPaymentIssue(data.payments);
        // if (hasIssues || hasPayments)
        if (hasIssues) setDialogOpen(true);
      }
    } catch (error) {
      console.error("Failed to check truck issues:", error);
    }
  };

   const prepareSubmitData = () => {
    const submitData = { ...formData, lr_number: lrNumber, resubmit: false };

    if (!submitData.broker_party_id) {
      submitData.broker_party_id = null;
    }
    submitData.package_items = packageRows.map((row) => ({
      packages: row.packages,
      description: row.description,
      actual_weight: parseFloat(row.actual_weight) || 0,
      charged_weight: parseFloat(row.charged_weight) || 0,
      rate: parseFloat(row.rate) || 0,
      amount: parseFloat(row.amount) || 0,
    }));

    delete submitData.vehicle_id;
    const dateFields = [
      "created_at",
      "loading_date",
      "unloading_date",
      "loading_in_date",
      "loading_out_date",
      "unloading_in_date",
      "unloading_out_date",
      "eway_bill_date",
      "eway_validity_date",
    ];
    dateFields.forEach((field) => {
      if (!submitData[field]) submitData[field] = null;
    });

    const numericFields = [
      "actual_weight",
      "charged_weight",
      "rate",
      "amount",
      "actual_weight2",
      "charged_weight2",
      "rate2",
      "amount2",
      "freight_rate",
      "freight_amt",
      "mazdoor_charges",
      "service_tax",
      "surcharge",
      "risk_charges",
      "total_amount",
      "tds_per",
      "tds_amt",
      "shortage_rate",
      "shortage_amt",
      "shortage_wt",
      "ad_mines_exp",
      "ad_diesel_exp",
      "ad_cash_exp",
      "total_advance",
      "commission",
      "other_exp",
      "net_amount",
      "net_payable",
      "st_charge",
      "pay_amount",
      "broker_total_amt",
      "broker_net_amt",
      "broker_commission_amt",
    ];
    numericFields.forEach((field) => {
      const num = parseFloat(submitData[field]);
      submitData[field] = isNaN(num) ? 0 : num;
    });

    const payAmount = safeParseFloat(submitData.pay_amount);
    const netPayable = safeParseFloat(submitData.net_payable);
    if (payAmount > 0) {
      submitData.bal_amount = (netPayable - payAmount).toFixed(2);
      submitData.paid_amount = payAmount;
    } else {
      submitData.bal_amount = netPayable;
      submitData.paid_amount = 0;
    }
    submitData.is_invoice = false;

    // if (!submitData.loading_date) {
    //   submitData.loading_date = new Date().toISOString().split("T")[0];
    // }

    return submitData;
  };

  const resetFormAfterSave = async () => {
    try {
      const response = await generateLRNumber();
      if (response?.lr_numbers?.length > 0) {
        setLrNumbers(response.lr_numbers);
        setLrNumber("");
        setFormData((prev) => ({
          ...prev,
          broker_party_id: "",
          broker_total_amt: "0",
          broker_net_amt: "0",
          broker_commission_amt: "0",
          packages: "",
          description: "",
          actual_weight: "0",
          charged_weight: "0",
          rate: "0",
          amount: "0",
          packages2: "",
          description2: "",
          actual_weight2: "0",
          charged_weight2: "0",
          rate2: "0",
          amount2: "0",
          pay_amount: "0",
          freight_amt: "0",
          mazdoor_charges: "0",
          service_tax: "0",
          surcharge: "0",
          risk_charges: "0",
          tds_per: "0",
          total_advance: "0",
          commission: "0",
          other_exp: "0",
          shortage_rate: "0",
          shortage_amt: "0",
          loading_in_date: "",
          unloading_in_date: "",
          loading_out_date: "",
          unloading_out_date: "",
          eway_validity_date: "",
          lr_number: "",
          value: "",
          created_at: new Date().toISOString().split("T")[0],
        }));
      }

      setTruckNumberInput("");
      setShowAppPaymentFields(false);
      setPackageRows([
        {
          id: 1,
          packages: "",
          description: "",
          actual_weight: "0",
          charged_weight: "0",
          rate: "0",
          amount: "0",
        },
      ]);
    } catch (err) {
      console.error("Failed to refresh LR numbers:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.party_id) {
      showSnackbar("Please select a Party/Consignor", "error");
      return;
    }

    if (!isEditMode && !lrNumber) {
      showSnackbar("Please select an LR number", "error");
      return;
    }

    try {
      if (isEditMode && id) {
        const submitData = prepareSubmitData();
        delete submitData.lr_number;
        delete submitData.resubmit;
        const response = await updateFreight(id, submitData);
        if (response) {
          showSnackbar("LR updated successfully!", "success");
          setTimeout(() => navigate("/dashboard/freight-list"), 1500);
        } else {
          showSnackbar("Update failed", "error");
        }
      } else {
        const submitData = prepareSubmitData();
        let response;

        try {
          response = await freightCreate(submitData);
        } catch (apiError) {
          // ── Direct API error catch ──

          const errorData = apiError?.response?.data || {};
          const errorMsg = errorData.message || "";
          const statusCode = apiError?.response?.status;

          if (
            statusCode === 400 &&
            (errorMsg.toLowerCase().includes("already used") ||
              errorMsg.toLowerCase().includes("please refresh") ||
              errorMsg.toLowerCase().includes("not available"))
          ) {
            setLrNumber("");
            setFormData((prev) => ({ ...prev, lr_number: "" }));
            setLrConflictDialog(true);
            return; // stop further execution
          }

          showSnackbar(
            errorMsg || "Failed to create freight. Please try again.",
            "error",
          );
          return;
        }

        // ── Response handling ──
        console.log("Response received:", response);

        if (!response || Object.keys(response).length === 0) {
          // Empty response = probably error
          showSnackbar("No response from server. Please try again.", "error");
          return;
        }

        if (response.message === "done") {
          showSnackbar("LR saved successfully!", "success");
          if (response?.lr_numbers?.length > 0) {
            setLrNumbers(response.lr_numbers);
            setLrNumber("");
          }
          setTimeout(() => navigate("/dashboard/freight-list"), 1500);
          await resetFormAfterSave();
        } else if (response.message === "already exists") {
          setDialogOpen1(true);
        } else if (
          response.message &&
          (response.message.toLowerCase().includes("already used") ||
            response.message.toLowerCase().includes("please refresh"))
        ) {
          // ── LR conflict safety net (agar response me aata hai) ──
          setLrNumber("");
          setFormData((prev) => ({ ...prev, lr_number: "" }));
          setLrConflictDialog(true);
        } else {
          showSnackbar(response.message || "Submission failed", "error");
        }
      }
    } catch (err) {
      console.error("Outer Submit Error:", err);
      showSnackbar("An unexpected error occurred. Please try again.", "error");
    }
  };

  const handleReSubmit = async () => {
    try {
      const submitData = prepareSubmitData();
      submitData.resubmit = true;
      const response = await freightCreate(submitData);
      if (response?.message === "done") {
        setDialogOpen1(false);
        showSnackbar("LR saved successfully!", "success");
        setTimeout(() => navigate("/dashboard/freight-list"), 1500);
        await resetFormAfterSave();
      } else {
        showSnackbar(response?.message || "Submission failed", "error");
      }
    } catch (err) {
      console.error("ReSubmit Error:", err);
      const errorMsg = err.response?.data?.message || "";
      const statusCode = err.response?.status;

      if (
        statusCode === 400 &&
        (errorMsg.toLowerCase().includes("lr number already used") ||
          errorMsg.toLowerCase().includes("please refresh") ||
          errorMsg.toLowerCase().includes("not available"))
      ) {
        setDialogOpen1(false); // duplicate dialog band karo
        setLrNumber("");
        setFormData((prev) => ({ ...prev, lr_number: "" }));
        setLrConflictDialog(true); // LR conflict dialog kholo
      } else {
        showSnackbar("An error occurred. Please try again.", "error");
      }
    }
  };

  const formatOnlyDate = (dateTimeString) => {
    if (!dateTimeString) return "-";
    const date = new Date(dateTimeString);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const refreshLRNumbers = async () => {
    try {
      setGeneratingLR(true);
      const response = await generateLRNumber();
      if (response?.lr_numbers?.length > 0) {
        setLrNumbers(response.lr_numbers);
        setLrNumber("");
        setFormData((prev) => ({ ...prev, lr_number: "" }));
        showSnackbar("LR list refreshed!", "success");
      }
    } catch (error) {
      console.error("Failed to refresh LR numbers:", error);
      showSnackbar("Failed to refresh LR list", "error");
    } finally {
      setGeneratingLR(false);
    }
  };

  // ── Blank LR Handlers (NEW) ──

  // Checkbox toggle in dropdown
  const handleBlankCheckboxToggle = (e, lrNum) => {
    e.stopPropagation(); // ← MenuItem click ko rok do
    setBlankSelectedLRs((prev) =>
      prev.includes(lrNum) ? prev.filter((n) => n !== lrNum) : [...prev, lrNum],
    );
  };

  // "Mark as Blank" button click → confirmation open
  const handleBlankButtonClick = (e) => {
    setBlankAnchorEl(e.currentTarget);
    setBlankConfirmOpen(true);
  };

  const handleBlankConfirm = async () => {
    if (blankSelectedLRs.length === 0) return;

    setMarkingBlank(true);
    try {
      const blankResponse = await markLRAsBlank(blankSelectedLRs, blankReason);

      if (blankResponse?.message === "done" || blankResponse?.success) {
        if (blankResponse?.lr_numbers?.length > 0) {
          setLrNumbers(blankResponse.lr_numbers);

          if (blankSelectedLRs.includes(lrNumber)) {
            setLrNumber("");
            setFormData((prev) => ({ ...prev, lr_number: "" }));
          }

          showSnackbar(
            `${blankSelectedLRs.length} LR(s) marked blank, fresh slots updated!`,
            "success",
          );
        }
      } else {
        setLrNumbers((prev) =>
          prev.filter((n) => !blankSelectedLRs.includes(n)),
        );
        showSnackbar("LRs removed locally (API returned error)", "warning");
      }

      setBlankSelectedLRs([]);
      setBlankReason("");
      setBlankConfirmOpen(false);
      setBlankAnchorEl(null);
    } catch (error) {
      console.error("Blank LR Error:", error);
      setLrNumbers((prev) => prev.filter((n) => !blankSelectedLRs.includes(n)));
      setBlankSelectedLRs([]);
      setBlankReason("");
      setBlankConfirmOpen(false);
      setBlankAnchorEl(null);
      showSnackbar("LRs removed locally (Network error)", "warning");
    } finally {
      setMarkingBlank(false);
    }
  };

  // Confirmation cancel
  const handleBlankCancel = () => {
    setBlankConfirmOpen(false);
    setBlankAnchorEl(null);
    setBlankReason("");
  };

  if (generatingLR || loadingData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <CircularProgress sx={{ color: brand }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        px: 0,
        pt: 0,
        mt: 0,
        maxWidth: 1200,
        mx: "auto",
        pb: { xs: 9, md: 0 },
        width: "100%",
      }}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        <Paper
          sx={{
            borderRadius: "4px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
            overflow: "hidden",
          }}
        >
          {/* ── Header ── */}
          <Box
            sx={{
              px: { xs: 1.5, md: 2.5 },
              py: 1.5,
              backgroundColor: "#f8fafc",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            {isMobile ? (
              // ══════════ MOBILE HEADER ══════════
              <Stack spacing={1.25}>
                {/* Row 1: Title left, Back right */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Box
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: "4px",
                        bgcolor: alpha(brand, 0.1),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <TruckIcon sx={{ color: brand, fontSize: 18 }} />
                    </Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#111827",
                        fontSize: "1rem",
                        lineHeight: 1.2,
                      }}
                    >
                      {isEditMode ? "Edit LR" : "LR Creation"}
                    </Typography>
                    {isEditMode && lrNumber && (
                      <Chip
                        label={`LR: ${lrNumber}`}
                        size="small"
                        sx={{
                          borderRadius: "4px",
                          bgcolor: alpha(brand, 0.1),
                          color: brand,
                          fontSize: "0.65rem",
                          fontWeight: 600,
                          height: 20,
                        }}
                      />
                    )}
                  </Stack>

                  <Button
                    startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
                    onClick={() => navigate("/dashboard/freight-list")}
                    size="small"
                    sx={{
                      borderRadius: "4px",
                      textTransform: "none",
                      fontSize: "0.75rem",
                      height: 32,
                      px: 1.5,
                      border: "1px solid #d1d5db",
                      color: "#6b7280",
                      boxShadow: "none",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                      "&:hover": {
                        borderColor: brand,
                        color: brand,
                        bgcolor: alpha(brand, 0.04),
                        boxShadow: "none",
                      },
                    }}
                  >
                    Back
                  </Button>
                </Box>

                {/* Row 3: Mark Blank (always visible, disabled when 0 selected) + Refresh */}
                {!isEditMode && lrNumbers.length > 0 && (
                  <Stack direction="row" spacing={1}>
                    <Button
                      onClick={handleBlankButtonClick}
                      disabled={markingBlank || blankSelectedLRs.length === 0}
                      size="small"
                      fullWidth
                      startIcon={
                        markingBlank ? (
                          <CircularProgress size={12} sx={{ color: "#fff" }} />
                        ) : (
                          <BlankIcon sx={{ fontSize: 14 }} />
                        )
                      }
                      sx={{
                        height: 32,
                        borderRadius: "4px",
                        bgcolor: "#f59e0b",
                        color: "#fff",
                        textTransform: "none",
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                        boxShadow: "none",
                        "&:hover": { bgcolor: "#d97706", boxShadow: "none" },
                        "&.Mui-disabled": {
                          bgcolor: "#f3f4f6",
                          color: "#9ca3af",
                        },
                      }}
                    >
                      {blankSelectedLRs.length > 0
                        ? `Mark ${blankSelectedLRs.length} Blank`
                        : "Mark Blank"}
                    </Button>

                    <Button
                      onClick={refreshLRNumbers}
                      disabled={generatingLR}
                      size="small"
                      fullWidth
                      startIcon={
                        generatingLR ? (
                          <CircularProgress size={12} sx={{ color: brand }} />
                        ) : (
                          <RefreshIcon sx={{ fontSize: 14 }} />
                        )
                      }
                      sx={{
                        height: 32,
                        borderRadius: "4px",
                        border: "1px solid",
                        borderColor: alpha(brand, 0.3),
                        bgcolor: alpha(brand, 0.06),
                        color: brand,
                        textTransform: "none",
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                        boxShadow: "none",
                        "&:hover": {
                          bgcolor: alpha(brand, 0.15),
                          borderColor: brand,
                          boxShadow: "none",
                        },
                        "&.Mui-disabled": {
                          color: "#d1d5db",
                          borderColor: "#e5e7eb",
                        },
                      }}
                    >
                      Refresh
                    </Button>
                  </Stack>
                )}

                {/* Row 2: LR Dropdown (create mode only) */}
                {!isEditMode && lrNumbers.length > 0 && (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    value={lrNumber}
                    onChange={(e) => {
                      setLrNumber(e.target.value);
                      setFormData((prev) => ({
                        ...prev,
                        lr_number: e.target.value,
                      }));
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: 34,
                        fontSize: "0.75rem",
                        borderRadius: "4px",
                        bgcolor: alpha(brand, 0.06),
                        "& fieldset": { borderColor: alpha(brand, 0.3) },
                        "&:hover fieldset": { borderColor: brand },
                        "&.Mui-focused fieldset": { borderColor: brand },
                      },
                      "& .MuiSelect-select": {
                        py: "6px !important",
                        color: lrNumber ? brand : "#9ca3af",
                        fontWeight: 700,
                      },
                    }}
                    SelectProps={{
                      native: false,
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 300,
                            "& .MuiMenuItem-root": {
                              fontSize: "0.75rem",
                              py: 0.5,
                              px: 1,
                            },
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem
                      value=""
                      disabled
                      sx={{ fontSize: "0.75rem", color: "#9ca3af" }}
                    >
                      -- Select LR --
                    </MenuItem>
                    {lrNumbers.map((num) => {
                      const isBlankChecked = blankSelectedLRs.includes(num);
                      const isSelectedLR = lrNumber === num;
                      return (
                        <MenuItem
                          key={num}
                          value={num}
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            bgcolor: isBlankChecked
                              ? alpha("#f59e0b", 0.12)
                              : isSelectedLR
                                ? alpha(brand, 0.08)
                                : "transparent",
                            "&:hover": {
                              bgcolor: isBlankChecked
                                ? alpha("#f59e0b", 0.2)
                                : alpha(brand, 0.06),
                            },
                          }}
                        >
                          <ListItemText
                            primary={num}
                            primaryTypographyProps={{
                              fontWeight: isSelectedLR ? 700 : 500,
                              color: isBlankChecked
                                ? "#f59e0b"
                                : isSelectedLR
                                  ? brand
                                  : "#374151",
                              fontSize: "0.75rem",
                              textDecoration: isBlankChecked
                                ? "line-through"
                                : "none",
                            }}
                          />
                          <ListItemIcon
                            sx={{
                              minWidth: "auto !important",
                              ml: 1,
                              cursor: "pointer",
                            }}
                            onClick={(e) => handleBlankCheckboxToggle(e, num)}
                          >
                            {isBlankChecked ? (
                              <CheckBoxCheckedIcon
                                sx={{ fontSize: 18, color: "#f59e0b" }}
                              />
                            ) : (
                              <CheckBoxBlankIcon
                                sx={{ fontSize: 18, color: "#d1d5db" }}
                              />
                            )}
                          </ListItemIcon>
                        </MenuItem>
                      );
                    })}
                  </TextField>
                )}

                {/* Row 4: Date, full width */}
                <TextField
                  type="date"
                  label="Date"
                  name="created_at"
                  value={formData.created_at}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  fullWidth
                  sx={textFieldSx}
                />
              </Stack>
            ) : (
              // ══════════ DESKTOP HEADER — unchanged ══════════
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Stack direction="row" spacing={1.5} alignItems="center">
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "4px",
                      bgcolor: alpha(brand, 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <TruckIcon sx={{ color: brand, fontSize: 18 }} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "#111827",
                        fontSize: "1rem",
                        lineHeight: 1.2,
                        textAlign: "left",
                      }}
                    >
                      {isEditMode ? "Edit LR" : "LR Creation"}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "0.7rem", color: "#6b7280", mt: 0.2 }}
                    >
                      {isEditMode
                        ? `Editing LR ID: ${id}`
                        : "Fill in the details below to create an LR"}
                    </Typography>
                  </Box>
                  {!isEditMode && lrNumbers.length > 0 && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography
                        sx={{
                          fontSize: "0.72rem",
                          color: "#6b7280",
                          fontWeight: 500,
                          ml: 2,
                        }}
                      >
                        LR No:
                      </Typography>

                      <Box
                        sx={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          select
                          size="small"
                          value={lrNumber}
                          onChange={(e) => {
                            setLrNumber(e.target.value);
                            setFormData((prev) => ({
                              ...prev,
                              lr_number: e.target.value,
                            }));
                          }}
                          sx={{
                            minWidth: 200,
                            "& .MuiOutlinedInput-root": {
                              height: 28,
                              fontSize: "0.75rem",
                              borderRadius: "4px",
                              bgcolor: alpha(brand, 0.06),
                              "& fieldset": { borderColor: alpha(brand, 0.3) },
                              "&:hover fieldset": { borderColor: brand },
                              "&.Mui-focused fieldset": { borderColor: brand },
                            },
                            "& .MuiSelect-select": {
                              py: "4px !important",
                              color: lrNumber ? brand : "#9ca3af",
                              fontWeight: 700,
                            },
                          }}
                          SelectProps={{
                            native: false,
                            MenuProps: {
                              PaperProps: {
                                sx: {
                                  maxHeight: 300,
                                  minWidth: 220,
                                  "& .MuiMenuItem-root": {
                                    fontSize: "0.75rem",
                                    py: 0.5,
                                    px: 1,
                                  },
                                },
                              },
                            },
                          }}
                        >
                          <MenuItem
                            value=""
                            disabled
                            sx={{ fontSize: "0.75rem", color: "#9ca3af" }}
                          >
                            -- Select LR --
                          </MenuItem>
                          {lrNumbers.map((num) => {
                            const isBlankChecked =
                              blankSelectedLRs.includes(num);
                            const isSelectedLR = lrNumber === num;
                            return (
                              <MenuItem
                                key={num}
                                value={num}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  bgcolor: isBlankChecked
                                    ? alpha("#f59e0b", 0.12)
                                    : isSelectedLR
                                      ? alpha(brand, 0.08)
                                      : "transparent",
                                  "&:hover": {
                                    bgcolor: isBlankChecked
                                      ? alpha("#f59e0b", 0.2)
                                      : alpha(brand, 0.06),
                                  },
                                }}
                              >
                                <ListItemText
                                  primary={num}
                                  primaryTypographyProps={{
                                    fontWeight: isSelectedLR ? 700 : 500,
                                    color: isBlankChecked
                                      ? "#f59e0b"
                                      : isSelectedLR
                                        ? brand
                                        : "#374151",
                                    fontSize: "0.75rem",
                                    textDecoration: isBlankChecked
                                      ? "line-through"
                                      : "none",
                                  }}
                                />
                                <ListItemIcon
                                  sx={{
                                    minWidth: "auto !important",
                                    ml: 1,
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) =>
                                    handleBlankCheckboxToggle(e, num)
                                  }
                                >
                                  {isBlankChecked ? (
                                    <CheckBoxCheckedIcon
                                      sx={{ fontSize: 18, color: "#f59e0b" }}
                                    />
                                  ) : (
                                    <CheckBoxBlankIcon
                                      sx={{ fontSize: 18, color: "#d1d5db" }}
                                    />
                                  )}
                                </ListItemIcon>
                              </MenuItem>
                            );
                          })}
                        </TextField>

                        {blankSelectedLRs.length > 0 && (
                          <Button
                            onClick={handleBlankButtonClick}
                            disabled={markingBlank}
                            size="small"
                            startIcon={
                              markingBlank ? (
                                <CircularProgress
                                  size={12}
                                  sx={{ color: "#fff" }}
                                />
                              ) : (
                                <BlankIcon sx={{ fontSize: 14 }} />
                              )
                            }
                            sx={{
                              ml: 1,
                              height: 28,
                              borderRadius: "4px",
                              bgcolor: "#f59e0b",
                              color: "#fff",
                              textTransform: "none",
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              px: 1.2,
                              whiteSpace: "nowrap",
                              boxShadow: "none",
                              "&:hover": {
                                bgcolor: "#d97706",
                                boxShadow: "none",
                              },
                            }}
                          >
                            Mark {blankSelectedLRs.length} Blank
                          </Button>
                        )}
                      </Box>

                      <IconButton
                        onClick={refreshLRNumbers}
                        disabled={generatingLR}
                        size="small"
                        sx={{
                          width: 28,
                          height: 28,
                          borderRadius: "4px",
                          border: "1px solid",
                          borderColor: alpha(brand, 0.3),
                          bgcolor: alpha(brand, 0.06),
                          color: brand,
                          "&:hover": {
                            bgcolor: alpha(brand, 0.15),
                            borderColor: brand,
                          },
                          "&.Mui-disabled": {
                            color: "#d1d5db",
                            borderColor: "#e5e7eb",
                          },
                        }}
                      >
                        {generatingLR ? (
                          <CircularProgress size={14} sx={{ color: brand }} />
                        ) : (
                          <RefreshIcon sx={{ fontSize: 16 }} />
                        )}
                      </IconButton>
                    </Box>
                  )}

                  {isEditMode && lrNumber && (
                    <Chip
                      label={`LR: ${lrNumber}`}
                      size="small"
                      sx={{
                        borderRadius: "4px",
                        bgcolor: alpha(brand, 0.1),
                        color: brand,
                        fontSize: "0.65rem",
                        fontWeight: 600,
                        height: 20,
                      }}
                    />
                  )}
                </Stack>

                <Stack direction="row" spacing={1.5} alignItems="center">
                  <TextField
                    type="date"
                    label="Date"
                    name="created_at"
                    value={formData.created_at}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                    size="small"
                    sx={{ ...textFieldSx, width: 160 }}
                  />
                  <Button
                    startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
                    onClick={() => navigate("/dashboard/freight-list")}
                    size="small"
                    sx={{
                      borderRadius: "4px",
                      textTransform: "none",
                      fontSize: "0.75rem",
                      height: 44,
                      px: 2,
                      border: "1px solid #d1d5db",
                      color: "#6b7280",
                      boxShadow: "none",
                      "&:hover": {
                        borderColor: brand,
                        color: brand,
                        bgcolor: alpha(brand, 0.04),
                        boxShadow: "none",
                      },
                    }}
                  >
                    Back to List
                  </Button>
                </Stack>
              </Box>
            )}
          </Box>

          {/* ── Form Content ── */}
          <Box sx={{ p: 2.5 }}>
            <SectionTitle title="Basic Information" icon={BusinessIcon} />

            {/* Toggle + Controls */}
            <Box
              sx={{
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: { xs: "stretch", md: "center" },
                flexDirection: { xs: "column", md: "row" },
                flexWrap: "wrap",
                gap: 1.25,
              }}
            >
              <ToggleButtonGroup
                value={vehicleType}
                exclusive
                onChange={handleVehicleTypeChange}
                size="small"
                fullWidth={isMobile}
                sx={{
                  "& .MuiToggleButton-root": {
                    borderRadius: "4px !important",
                    border: "1px solid #e5e7eb !important",
                    bgcolor: "#f8fafc",
                    textTransform: "none",
                    fontSize: "0.75rem",
                    px: 2,
                    color: "#6b7280",
                    "&.Mui-selected": {
                      bgcolor: brand,
                      color: "#fff",
                      "&:hover": { bgcolor: "#4338ca" },
                    },
                  },
                }}
              >
                <ToggleButton value="hire">🚛 Hire Vehicle</ToggleButton>
                <ToggleButton value="self">🚗 Self Vehicle</ToggleButton>
              </ToggleButtonGroup>

              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={{ xs: "space-between", md: "flex-start" }}
                flexWrap="wrap"
                sx={{ width: { xs: "100%", md: "auto" } }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formData.is_remember}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          is_remember: e.target.checked,
                        }))
                      }
                      size="small"
                      sx={{ color: brand, "&.Mui-checked": { color: brand } }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "0.75rem" }}>
                      Remember
                    </Typography>
                  }
                />
                <Button
                  onClick={() => setShowAppPaymentFields((prev) => !prev)}
                  size="small"
                  sx={{
                    borderRadius: "4px",
                    textTransform: "none",
                    bgcolor: alpha(brand, 0.08),
                    color: brand,
                    fontSize: "0.7rem",
                    boxShadow: "none",
                    px: 1,
                    whiteSpace: "nowrap",
                    "&:hover": {
                      bgcolor: alpha(brand, 0.16),
                      boxShadow: "none",
                    },
                  }}
                >
                  {showAppPaymentFields
                    ? "Hide Advance Payment"
                    : "Add Advance Payment"}
                </Button>
              </Stack>
            </Box>

            {/* ── Row 1 ── */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  fullWidth
                  options={consignorOptions}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    consignorOptions.find(
                      (opt) => opt.party_id === formData.party_id,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.party_id === value?.party_id
                  }
                  onChange={(event, newValue) =>
                    setFormData((prev) => ({
                      ...prev,
                      party_id: newValue?.party_id || "",
                      commission: newValue?.commission || "0",
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 44,
                      padding: "0 8px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Party / Consignor"
                      required
                      size="small"
                      sx={textFieldSx}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  fullWidth
                  options={consigneeOptions}
                  getOptionLabel={(option) => option?.name || ""}
                  value={
                    consigneeOptions.find(
                      (opt) => opt.party_id === formData.consignee_party_id,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.party_id === value?.party_id
                  }
                  onChange={(event, newValue) =>
                    setFormData((prev) => ({
                      ...prev,
                      consignee_party_id: newValue?.party_id || "",
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 44,
                      padding: "0 8px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Consignee"
                      size="small"
                      sx={textFieldSx}
                      required
                    />
                  )}
                />
              </Grid>

              {/* ── Broker (Optional) ── */}
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  fullWidth
                  options={brokerOptions}
                  getOptionLabel={(option) => {
                    const commission = parseFloat(option?.commission || 0);
                    return commission > 0
                      ? `${option?.name || ""} (${commission.toFixed(2)}%)`
                      : option?.name || "";
                  }}
                  value={
                    brokerOptions.find(
                      (opt) => opt.party_id === formData.broker_party_id,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.party_id === value?.party_id
                  }
                  onChange={(event, newValue) => {
                    setFormData((prev) => ({
                      ...prev,
                      broker_party_id: newValue?.party_id || "",
                    }));
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 44,
                      padding: "0 8px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Broker"
                      size="small"
                      sx={textFieldSx}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                {vehicleType === "hire" ? (
                  <TextField
                    fullWidth
                    label="Truck / Vehicle No."
                    name="truck_no"
                    value={formData.truck_no}
                    onChange={(e) => {
                      handleChange(e);
                      setTruckNumberInput(e.target.value);
                    }}
                    onBlur={() =>
                      checkTrukIssue(formData.truck_no || truckNumberInput)
                    }
                    size="small"
                    sx={textFieldSx}
                    required
                  />
                ) : (
                  <Autocomplete
                    fullWidth
                    options={vehicleOptions}
                    getOptionLabel={(option) =>
                      option.vehicle_number || option.vehicleNumber || ""
                    }
                    value={
                      vehicleOptions.find(
                        (opt) =>
                          (opt.vehicle_number || opt.vehicleNumber) ===
                          formData.truck_no,
                      ) || null
                    }
                    onChange={handleVehicleSelect}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: 44,
                        padding: "0 8px !important",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Vehicle"
                        size="small"
                        sx={textFieldSx}
                        required
                      />
                    )}
                  />
                )}
              </Grid>
            </Grid>

            {/* ── Row 2 ── */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="From"
                  name="from_location"
                  value={formData.from_location}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="To"
                  name="to_location"
                  value={formData.to_location}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                  required
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="Loading Date"
                  name="loading_date"
                  value={formData.loading_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="Loading Out Date"
                  name="loading_out_date"
                  value={formData.loading_out_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
            </Grid>

            {/* ── Row 3 ── */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="Unloading Date"
                  name="unloading_date"
                  value={formData.unloading_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="Unloading Out Date"
                  name="unloading_out_date"
                  value={formData.unloading_out_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="E-Way Bill No."
                  name="eway_bill_no"
                  value={formData.eway_bill_no}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="E-Way Bill Date"
                  name="eway_bill_date"
                  value={formData.eway_bill_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
            </Grid>

            {/* ── Row 4 ── */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label="E-Way Validity Date"
                  name="eway_validity_date"
                  value={formData.eway_validity_date}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Classification of Goods"
                  name="classification_of_goods"
                  value={formData.classification_of_goods}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Method of Packing"
                  name="method_of_packing"
                  value={formData.method_of_packing}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Invoice No."
                  name="invoice_no"
                  value={formData.invoice_no}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
            </Grid>

            {/* ── Row 5 ── */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Transporter Name"
                  name="truck_owner"
                  value={formData.truck_owner}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Phone No."
                  name="phone_no"
                  value={formData.phone_no}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <Autocomplete
                  fullWidth
                  options={indianStates}
                  getOptionLabel={(option) => option?.label || ""}
                  value={
                    indianStates.find((s) => s.value === formData.state) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.value === value?.value
                  }
                  onChange={(event, newValue) =>
                    setFormData((prev) => ({
                      ...prev,
                      state: newValue?.value || "",
                    }))
                  }
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: 44,
                      padding: "0 8px !important",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State"
                      size="small"
                      sx={textFieldSx}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  label="Value"
                  name="value"
                  value={formData.value}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
            </Grid>

            {/* ── Package Table ── */}
            <Box sx={{ borderTop: "1px solid #e5e7eb", mt: 3, pt: 0.5 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <SectionTitle title="Package & Weight Details" icon={DescIcon} />
              <Button
                size="small"
                startIcon={<AddIcon sx={{ fontSize: 15 }} />}
                onClick={handleAddPackageRow}
                sx={{
                  borderRadius: "4px",
                  textTransform: "none",
                  bgcolor: alpha(brand, 0.08),
                  color: brand,
                  fontSize: "0.7rem",
                  boxShadow: "none",
                  height: 30,
                  mb: 2,
                  px: 1,
                  "&:hover": { bgcolor: alpha(brand, 0.16), boxShadow: "none" },
                }}
              >
                Add Row
              </Button>
            </Box>

            {isMobile ? (
              // ── Mobile: compact card list, no horizontal scroll ──
              <Stack spacing={1} sx={{ mb: 2 }}>
                {packageRows.map((row, idx) => (
                  <Paper
                    key={row.id}
                    elevation={0}
                    sx={{
                      border: "1px solid #e5e7eb",
                      borderRadius: "4px",
                      p: 1.25,
                      bgcolor: "#fafafa",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 700,
                          color: brand,
                        }}
                      >
                        Row #{idx + 1}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => handleRemovePackageRow(row.id)}
                        sx={{ color: "#dc2626", p: 0.5, borderRadius: "4px" }}
                      >
                        <DeleteIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Box>

                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          value={row.packages}
                          onChange={(e) =>
                            handlePackageRowChange(
                              row.id,
                              "packages",
                              e.target.value,
                            )
                          }
                          size="small"
                          label="Packages"
                          sx={tableFieldSx}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          value={row.description}
                          onChange={(e) =>
                            handlePackageRowChange(
                              row.id,
                              "description",
                              e.target.value,
                            )
                          }
                          size="small"
                          label="Description"
                          sx={tableFieldSx}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          type="number"
                          value={row.actual_weight}
                          onChange={(e) =>
                            handlePackageRowChange(
                              row.id,
                              "actual_weight",
                              e.target.value,
                            )
                          }
                          size="small"
                          label="Actual Wt."
                          sx={tableFieldSx}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          type="number"
                          value={row.charged_weight}
                          onChange={(e) =>
                            handlePackageRowChange(
                              row.id,
                              "charged_weight",
                              e.target.value,
                            )
                          }
                          size="small"
                          label="Charged Wt."
                          sx={tableFieldSx}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                ))}
              </Stack>
            ) : (
              // ── Desktop: original table, unchanged ──
              <TableContainer
                sx={{
                  mb: 2,
                  borderRadius: "4px",
                  border: "1px solid #e5e7eb",
                  overflowX: "auto",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#f8fafc" }}>
                      {[
                        "Packages",
                        "Description",
                        "Actual Wt.",
                        "Charged Wt.",
                        "",
                      ].map((h) => (
                        <TableCell
                          key={h}
                          sx={{
                            fontWeight: 600,
                            fontSize: "0.7rem",
                            color: "#374151",
                            borderBottom: "1px solid #e5e7eb",
                          }}
                        >
                          {h}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {packageRows.map((row) => (
                      <TableRow key={row.id}>
                        <TableCell
                          sx={{
                            minWidth: 120,
                            borderBottom: "1px solid #f1f5f9",
                          }}
                        >
                          <TextField
                            fullWidth
                            value={row.packages}
                            onChange={(e) =>
                              handlePackageRowChange(
                                row.id,
                                "packages",
                                e.target.value,
                              )
                            }
                            size="small"
                            placeholder="Packages"
                            sx={tableFieldSx}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: 200,
                            borderBottom: "1px solid #f1f5f9",
                          }}
                        >
                          <TextField
                            fullWidth
                            value={row.description}
                            onChange={(e) =>
                              handlePackageRowChange(
                                row.id,
                                "description",
                                e.target.value,
                              )
                            }
                            size="small"
                            placeholder="Description"
                            sx={tableFieldSx}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: 120,
                            borderBottom: "1px solid #f1f5f9",
                          }}
                        >
                          <TextField
                            fullWidth
                            type="number"
                            value={row.actual_weight}
                            onChange={(e) =>
                              handlePackageRowChange(
                                row.id,
                                "actual_weight",
                                e.target.value,
                              )
                            }
                            size="small"
                            placeholder="Actual Wt."
                            sx={tableFieldSx}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: 120,
                            borderBottom: "1px solid #f1f5f9",
                          }}
                        >
                          <TextField
                            fullWidth
                            type="number"
                            value={row.charged_weight}
                            onChange={(e) =>
                              handlePackageRowChange(
                                row.id,
                                "charged_weight",
                                e.target.value,
                              )
                            }
                            size="small"
                            placeholder="Charged Wt."
                            sx={tableFieldSx}
                          />
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: 50,
                            textAlign: "center",
                            borderBottom: "1px solid #f1f5f9",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleRemovePackageRow(row.id)}
                            sx={{
                              color: "#dc2626",
                              p: 0.5,
                              borderRadius: "4px",
                            }}
                          >
                            <DeleteIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {/* ── Additional Info ── */}
            <Box sx={{ borderTop: "1px solid #e5e7eb", mt: 3, pt: 0.5 }} />
            <SectionTitle title="Additional Information" icon={DescIcon} />

            <Grid container spacing={2} sx={{ mb: 2 }}>
              {/* Broker Total Amount */}
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Broker Total Amount"
                  name="broker_total_amt"
                  value={formData.broker_total_amt}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                  InputProps={{
                    startAdornment: (
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "#6b7280",
                          fontWeight: 600,
                          mr: 0.5,
                        }}
                      >
                        ₹
                      </Typography>
                    ),
                  }}
                />
              </Grid>

              {/* Broker Net Amount */}
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Broker Net Amount"
                  name="broker_net_amt"
                  value={formData.broker_net_amt}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                  InputProps={{
                    startAdornment: (
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "#6b7280",
                          fontWeight: 600,
                          mr: 0.5,
                        }}
                      >
                        ₹
                      </Typography>
                    ),
                  }}
                />
              </Grid>

              {/* Broker Commission Amount */}
              <Grid item xs={6} sm={6} md={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Broker Commission Amt"
                  name="broker_commission_amt"
                  value={formData.broker_commission_amt}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                  InputProps={{
                    startAdornment: (
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "#10b981",
                          fontWeight: 700,
                          mr: 0.5,
                        }}
                      >
                        ₹
                      </Typography>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            {/* Remark */}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  label="Remark / Additional Info"
                  name="additional_info"
                  value={formData.additional_info}
                  onChange={handleChange}
                  size="small"
                  sx={textFieldSx}
                />
              </Grid>
            </Grid>

            {/* ── Advance Payment ── */}
            {showAppPaymentFields && (
              <>
                <Box sx={{ borderTop: "1px solid #e5e7eb", mt: 3, pt: 0.5 }} />
                <SectionTitle
                  title="Advance Payment Details"
                  icon={PaymentIcon}
                />
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} md={3}>
                    <TextField
                      fullWidth
                      type="number"
                      label="Pay Amount"
                      name="pay_amount"
                      value={formData.pay_amount}
                      onChange={handleChange}
                      size="small"
                      sx={textFieldSx}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Payment To"
                      name="payment_to"
                      value={formData.payment_to}
                      onChange={handleChange}
                      size="small"
                      sx={textFieldSx}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="Payment Mode"
                      name="pay_mode"
                      value={formData.pay_mode}
                      onChange={handleChange}
                      size="small"
                      sx={textFieldSx}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3}>
                    <TextField
                      fullWidth
                      label="UPI / Cheque No."
                      name="cheque_upi_no"
                      value={formData.cheque_upi_no}
                      onChange={handleChange}
                      size="small"
                      sx={textFieldSx}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      multiline
                      rows={1}
                      label="Payment Description"
                      name="description_payment"
                      value={formData.description_payment}
                      onChange={handleChange}
                      size="small"
                      sx={textFieldSx}
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {/* ── Submit ── */}
            <Stack
              direction="row"
              spacing={1.5}
              justifyContent={{ xs: "stretch", md: "flex-end" }}
              sx={{ mt: 3 }}
            >
              <Button
                type="submit"
                variant="contained"
                fullWidth={isMobile}
                startIcon={<SaveIcon sx={{ fontSize: 15 }} />}
                sx={{
                  borderRadius: "4px",
                  textTransform: "none",
                  fontSize: "0.75rem",
                  px: 2.5,
                  py: 0.9,
                  bgcolor: brand,
                  boxShadow: "none",
                  "&:hover": { bgcolor: "#4338ca", boxShadow: "none" },
                }}
              >
                {isEditMode ? "Update LR" : "Save LR"}
              </Button>
            </Stack>
          </Box>
        </Paper>
      </form>

      {/* ── Issue Dialog ── */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        fullWidth
        maxWidth="xl"
        PaperProps={{ sx: { borderRadius: "4px", overflow: "hidden" } }}
      >
        <Box sx={{ bgcolor: "#d97706", px: 3, py: 2 }}>
          <Typography
            sx={{ fontWeight: 700, color: "#fff", fontSize: "0.9rem" }}
          >
            ⚠️ Issues / Pending Payments for this Vehicle
          </Typography>
        </Box>

        {freightOptions.length > 0 && (
          <>
            <Typography sx={{ p: 2, fontWeight: 600, fontSize: "0.8rem" }}>
              Issues Found:
            </Typography>
            <TableContainer sx={{ maxHeight: 400 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {[
                      "LR No",
                      "Issue Description",
                      "Recovery Amt",
                      "Party Name",
                      "Loading Date",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{
                          fontWeight: 600,
                          bgcolor: "#f8fafc",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {freightOptions.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell
                        sx={{
                          borderBottom: "1px solid #f1f5f9",
                          fontWeight: 600,
                        }}
                      >
                        {row.freight_id?.lr_number || "N/A"}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        {row.description}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderBottom: "1px solid #f1f5f9",
                          color: "#dc2626",
                          fontWeight: 600,
                        }}
                      >
                        ₹{parseFloat(row.recovery_amount || 0).toFixed(2)}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        {row.party_name}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        {row.freight_id?.loading_date || "N/A"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}

        {/* {paymentIssue.length > 0 && (
          <>
            <Typography
              sx={{ p: 2, fontWeight: 600, mt: 2, fontSize: "0.8rem" }}
            >
              Pending Payments:
            </Typography>
            <TableContainer sx={{ maxHeight: 300 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {[
                      "Payment ID",
                      "Total Amount",
                      "Paid Amount",
                      "Remaining",
                      "Date",
                    ].map((h) => (
                      <TableCell
                        key={h}
                        sx={{
                          fontWeight: 600,
                          bgcolor: "#f8fafc",
                          borderBottom: "1px solid #e5e7eb",
                        }}
                      >
                        {h}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentIssue.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        {row.freight_payment_id}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        ₹{row.total_amount?.toFixed(2)}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        ₹{row.paid_amount?.toFixed(2)}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        ₹{row.rem_amount?.toFixed(2)}
                      </TableCell>
                      <TableCell sx={{ borderBottom: "1px solid #f1f5f9" }}>
                        {formatOnlyDate(row.created_at)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )} */}

        <DialogActions sx={{ p: 2, gap: 1, flexWrap: "wrap" }}>
          <Button
            onClick={() => setDialogOpen(false)}
            sx={{
              borderRadius: "4px",
              bgcolor: brand,
              color: "#fff",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { bgcolor: "#4338ca", boxShadow: "none" },
            }}
          >
            Continue
          </Button>
          <Button
            onClick={() => setDialogOpen(false)}
            sx={{
              borderRadius: "4px",
              bgcolor: "#dc2626",
              color: "#fff",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { bgcolor: "#b91c1c", boxShadow: "none" },
            }}
          >
            Stop
          </Button>
          <Button
            onClick={() => navigate("/dashboard/issue-list")}
            sx={{
              borderRadius: "4px",
              bgcolor: "#10b981",
              color: "#fff",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { bgcolor: "#059669", boxShadow: "none" },
            }}
          >
            Resolve Issues
          </Button>
        </DialogActions>
      </Dialog>
      {/* ── Duplicate Dialog ── */}
      <Dialog
        open={dialogOpen1}
        onClose={() => setDialogOpen1(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: "4px", overflow: "hidden" } }}
      >
        <Box sx={{ bgcolor: "#dc2626", px: 3, py: 2 }}>
          <Typography
            sx={{ fontWeight: 700, color: "#fff", fontSize: "0.9rem" }}
          >
            ⚠️ Duplicate LR Found!
          </Typography>
        </Box>
        <Typography sx={{ p: 3, textAlign: "center", fontSize: "0.85rem" }}>
          A freight with same Truck No. and Loading Date already exists. Do you
          want to continue?
        </Typography>
        <DialogActions sx={{ p: 2, justifyContent: "center", gap: 1 }}>
          <Button
            onClick={handleReSubmit}
            sx={{
              borderRadius: "4px",
              bgcolor: brand,
              color: "#fff",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { bgcolor: "#4338ca", boxShadow: "none" },
            }}
          >
            Yes, Continue
          </Button>
          <Button
            onClick={() => setDialogOpen1(false)}
            sx={{
              borderRadius: "4px",
              bgcolor: "#dc2626",
              color: "#fff",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { bgcolor: "#b91c1c", boxShadow: "none" },
            }}
          >
            No, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── LR Conflict Dialog ── */}
      <Dialog
        open={lrConflictDialog}
        onClose={() => setLrConflictDialog(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: "4px", overflow: "hidden" } }}
      >
        {/* Warning Header */}
        <Box
          sx={{
            bgcolor: "#dc2626",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{ fontWeight: 700, color: "#fff", fontSize: "0.95rem" }}
          >
            ⚠️ LR Number Already Used
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ p: 3 }}>
          <Typography sx={{ fontSize: "0.9rem", color: "#374151", mb: 2 }}>
            Selected LR number has already been used by another user just now.
          </Typography>

          <Box
            sx={{
              bgcolor: alpha(brand, 0.06),
              border: `1px solid ${alpha(brand, 0.2)}`,
              borderRadius: "6px",
              p: 2,
              display: "flex",
              gap: 1.5,
              alignItems: "flex-start",
            }}
          >
            <Box
              sx={{
                bgcolor: brand,
                borderRadius: "50%",
                width: 24,
                height: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                mt: 0.3,
              }}
            >
              <RefreshIcon sx={{ color: "#fff", fontSize: 14 }} />
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: 600,
                  color: "#111827",
                  mb: 0.5,
                }}
              >
                How to fix?
              </Typography>
              <Typography sx={{ fontSize: "0.8rem", color: "#4b5563" }}>
                Click the{" "}
                <Box
                  component="span"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                    bgcolor: alpha(brand, 0.15),
                    color: brand,
                    px: 0.8,
                    py: 0.2,
                    borderRadius: "3px",
                    fontWeight: 600,
                  }}
                >
                  <RefreshIcon sx={{ fontSize: 12 }} /> Refresh
                </Box>{" "}
                button next to the LR dropdown to get a fresh list of available
                LR numbers, then select a new one and submit again.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Actions */}
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => {
              setLrConflictDialog(false);
              refreshLRNumbers(); // ← direct refresh trigger
            }}
            startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
            sx={{
              borderRadius: "4px",
              bgcolor: brand,
              color: "#fff",
              textTransform: "none",
              fontSize: "0.8rem",
              px: 2,
              boxShadow: "none",
              "&:hover": { bgcolor: "#4338ca", boxShadow: "none" },
            }}
          >
            Refresh LR List Now
          </Button>
          <Button
            onClick={() => setLrConflictDialog(false)}
            sx={{
              borderRadius: "4px",
              bgcolor: "#f3f4f6",
              color: "#6b7280",
              textTransform: "none",
              fontSize: "0.8rem",
              px: 2,
              boxShadow: "none",
              "&:hover": { bgcolor: "#e5e7eb", boxShadow: "none" },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Unified Snackbar ── */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          top: "80px !important",
        }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{
            borderRadius: "4px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            fontWeight: 600,
            fontSize: "0.82rem",
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Popover
        open={blankConfirmOpen}
        anchorEl={blankAnchorEl}
        onClose={handleBlankCancel}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            border: "1px solid #f59e0b",
            boxShadow: "0 8px 24px rgba(245,158,11,0.2)",
            width: 320,
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <Box sx={{ bgcolor: "#f59e0b", px: 2, py: 1.2 }}>
          <Typography
            sx={{ color: "#fff", fontWeight: 700, fontSize: "0.8rem" }}
          >
            ⚠️ Mark {blankSelectedLRs.length} LR(s) as Blank?
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ p: 2 }}>
          {/* Selected LRs Preview */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              mb: 1.5,
            }}
          >
            {blankSelectedLRs.map((lr) => (
              <Chip
                key={lr}
                label={lr}
                size="small"
                onDelete={() =>
                  setBlankSelectedLRs((prev) => prev.filter((n) => n !== lr))
                }
                sx={{
                  height: 22,
                  fontSize: "0.68rem",
                  fontWeight: 600,
                  bgcolor: alpha("#f59e0b", 0.15),
                  color: "#b45309",
                  borderRadius: "4px",
                  "& .MuiChip-deleteIcon": {
                    fontSize: 14,
                    color: "#d97706",
                    "&:hover": { color: "#dc2626" },
                  },
                }}
              />
            ))}
          </Box>

          {/* Reason Input */}
          <TextField
            fullWidth
            size="small"
            label="Reason (Optional)"
            placeholder="e.g., Page damaged, Print error..."
            value={blankReason}
            onChange={(e) => setBlankReason(e.target.value)}
            sx={{
              ...textFieldSx,
              "& .MuiInputBase-input": { fontSize: "0.75rem" },
            }}
          />

          <Typography sx={{ fontSize: "0.65rem", color: "#9ca3af", mt: 1 }}>
            Ye LRs dropdown se remove ho jayengi aur naye LRs generate hongi.
          </Typography>
        </Box>

        {/* Actions */}
        <Box
          sx={{
            px: 2,
            py: 1.2,
            bgcolor: "#f9fafb",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            onClick={handleBlankCancel}
            size="small"
            sx={{
              borderRadius: "4px",
              textTransform: "none",
              fontSize: "0.72rem",
              color: "#6b7280",
              "&:hover": { bgcolor: "#f3f4f6" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleBlankConfirm}
            disabled={markingBlank || blankSelectedLRs.length === 0}
            size="small"
            variant="contained"
            startIcon={
              markingBlank ? (
                <CircularProgress size={12} sx={{ color: "#fff" }} />
              ) : (
                <BlankIcon sx={{ fontSize: 14 }} />
              )
            }
            sx={{
              borderRadius: "4px",
              bgcolor: "#f59e0b",
              textTransform: "none",
              fontSize: "0.72rem",
              fontWeight: 700,
              boxShadow: "none",
              "&:hover": { bgcolor: "#d97706", boxShadow: "none" },
            }}
          >
            Confirm Blank
          </Button>
        </Box>
      </Popover>
    </Box>
  );
}
